import React, { useEffect, useState, useRef } from 'react';
import { HomeIcon, FileTextIcon, PlusIcon, UserIcon, SettingsIcon, ClipboardIcon, ClipboardCheckIcon, UsersIcon, ShoppingCartIcon, ChevronDownIcon, UserPlusIcon, AlertTriangleIcon, ReceiptIcon, FileIcon, CheckSquareIcon, BarChartIcon, DollarSignIcon, LayoutIcon, DatabaseIcon, PackageIcon, TruckIcon, GitBranchIcon, BookIcon, BookOpenIcon, KeyIcon, PercentIcon, CircleDotIcon, ScaleIcon, TagIcon, MessageSquareIcon, ClipboardListIcon, PieChartIcon, TrendingUpIcon, FileBarChart2Icon, LineChartIcon, CreditCardIcon, FileSignatureIcon, FilesIcon, CalendarIcon, ClockIcon, CoinsIcon, MenuIcon, XIcon, GlobeIcon, MinusSquareIcon, BuildingIcon, MailIcon, BriefcaseIcon, FolderIcon, LibraryIcon, BellIcon, FilterIcon, CheckIcon, BookmarkIcon, MapPinIcon, ShieldAlertIcon, ShieldCheckIcon } from 'lucide-react';
export function Navigation({
  currentView,
  setCurrentView
}) {
  const [dashboardMenuOpen, setDashboardMenuOpen] = useState(false);
  const [procurementMenuOpen, setProcurementMenuOpen] = useState(false);
  const [vendorMenuOpen, setVendorMenuOpen] = useState(false);
  const [apMenuOpen, setApMenuOpen] = useState(false);
  const [diMenuOpen, setDIMenuOpen] = useState(false);
  const [financialMenuOpen, setFinancialMenuOpen] = useState(false);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [reportsMenuOpen, setReportsMenuOpen] = useState(false);
  const [contractMenuOpen, setContractMenuOpen] = useState(false);
  const [expenseMenuOpen, setExpenseMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMobileSubmenu, setActiveMobileSubmenu] = useState(null);
  // Create refs for the dropdown buttons and menus
  const dashboardButtonRef = useRef(null);
  const dashboardMenuRef = useRef(null);
  const procurementButtonRef = useRef(null);
  const procurementMenuRef = useRef(null);
  const vendorButtonRef = useRef(null);
  const vendorMenuRef = useRef(null);
  const apButtonRef = useRef(null);
  const apMenuRef = useRef(null);
  const diButtonRef = useRef(null);
  const diMenuRef = useRef(null);
  const financialButtonRef = useRef(null);
  const financialMenuRef = useRef(null);
  const settingsButtonRef = useRef(null);
  const settingsMenuRef = useRef(null);
  const reportsButtonRef = useRef(null);
  const reportsMenuRef = useRef(null);
  const contractButtonRef = useRef(null);
  const contractMenuRef = useRef(null);
  const expenseButtonRef = useRef(null);
  const expenseMenuRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const mobileMenuButtonRef = useRef(null);
  // Define the active state for each menu section
  const isProcurementView = ['create-requisition', 'requisitions', 'purchase-orders', 'receipting', 'procurement-dashboard', 'catalogs', 'receipt-list'].includes(currentView);
  const isVendorView = ['vendor-management', 'vendors', 'onboard-vendor', 'vendor-details', 'compliance-check'].includes(currentView);
  const isApView = ['ap-management', 'invoice-entry', 'invoice-list', 'matching', 'ap-dashboard', 'credit-note-dashboard', 'credit-note-entry', 'credit-note-list', 'credit-note-details', 'rcti-list', 'rcti-entry', 'rcti-details', 'rcti-management'].includes(currentView);
  const isFinancialView = ['chart-of-accounts', 'ledger', 'delegations', 'currency-exchange', 'budget', 'tax-codes', 'rounding', 'tolerance', 'payments', 'communications', 'rules', 'workflows', 'bank-accounts', 'addresses'].includes(currentView);
  const isSettingsView = ['settings', 'users', 'license-manager', 'tags', 'notes', 'audit', 'countries', 'currency', 'email-configuration', 'messages', 'notifications', 'decimal-precision', 'status-management', 'document-traceability'].includes(currentView);
  const isReportsView = ['reports', 'reports-procurement', 'reports-ap', 'reports-requisition', 'reports-financial', 'reports-operational', 'reports-construction', 'reports-audit'].includes(currentView);
  const isContractView = ['contracts', 'contract-detail', 'add-contract', 'contract-variations', 'contract-amendments', 'contract-milestones', 'contract-payment-claims', 'contract-types', 'contract-management'].includes(currentView);
  const isExpenseView = ['expense-claims', 'expense-claim-detail', 'add-expense-claim', 'expense-approval', 'expense-reports', 'expense-management'].includes(currentView);
  const isDIView = ['tasks', 'document-review', 'document-library', 'file-library'].includes(currentView);
  const isDashboardView = ['dashboard'].includes(currentView);
  // Helper function to sort menu items with dashboard first, then alphabetically
  const sortMenuItems = (items, dashboardId) => {
    // First, find the dashboard item
    const dashboardItem = items.find(item => item.id === dashboardId || item.label.includes('Dashboard'));
    // Filter out the dashboard item to sort the rest alphabetically
    const otherItems = items.filter(item => item !== dashboardItem).sort((a, b) => a.label.localeCompare(b.label));
    // Return the dashboard item first, followed by alphabetically sorted items
    return dashboardItem ? [dashboardItem, ...otherItems] : otherItems;
  };
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: HomeIcon,
    isDropdown: false,
    isActive: isDashboardView
  }, {
    id: 'di-management',
    label: 'DI',
    icon: FileTextIcon,
    tooltip: 'Document Intelligence',
    isDropdown: true,
    isActive: isDIView,
    children: [{
      id: 'tasks',
      label: 'Tasks',
      icon: CheckIcon
    }, {
      id: 'document-review',
      label: 'Document Review',
      icon: CheckSquareIcon
    }, {
      id: 'document-library',
      label: 'Document Library',
      icon: LibraryIcon
    }, {
      id: 'file-library',
      label: 'File Library',
      icon: FolderIcon
    }]
  }, {
    id: 'vendor-management',
    label: 'VM',
    icon: UsersIcon,
    tooltip: 'Vendor Management',
    isDropdown: true,
    isActive: isVendorView,
    children: sortMenuItems([{
      id: 'onboard-vendor',
      label: 'Add New Vendor',
      icon: UserPlusIcon
    }, {
      id: 'compliance-check',
      label: 'Compliance Check',
      icon: AlertTriangleIcon
    }, {
      id: 'vendor-management',
      label: 'Vendor Dashboard',
      icon: UsersIcon
    }, {
      id: 'vendors',
      label: 'Vendor List',
      icon: FileTextIcon
    }], 'vendor-management')
  }, {
    id: 'procurement',
    label: 'PO',
    icon: ShoppingCartIcon,
    tooltip: 'Procurement',
    isDropdown: true,
    isActive: isProcurementView,
    children: sortMenuItems([{
      id: 'catalogs',
      label: 'Catalogs',
      icon: BookOpenIcon
    }, {
      id: 'create-po',
      label: 'Create Purchase Order',
      icon: PlusIcon
    }, {
      id: 'create-requisition',
      label: 'Create Requisition',
      icon: PlusIcon
    }, {
      id: 'procurement-dashboard',
      label: 'Dashboard',
      icon: BarChartIcon
    }, {
      id: 'purchase-orders',
      label: 'Purchase Orders',
      icon: ClipboardCheckIcon
    }, {
      id: 'requisitions',
      label: 'Requisitions',
      icon: ClipboardIcon
    }, {
      id: 'receipt-list',
      label: 'Goods Receipts',
      icon: ClipboardListIcon
    }], 'procurement-dashboard')
  }, {
    id: 'contract-management',
    label: 'CM',
    icon: FileSignatureIcon,
    tooltip: 'Contract Management',
    isDropdown: true,
    isActive: isContractView,
    children: sortMenuItems([{
      id: 'add-contract',
      label: 'Add New Contract',
      icon: PlusIcon
    }, {
      id: 'contract-amendments',
      label: 'Amendments',
      icon: FileTextIcon
    }, {
      id: 'contract-detail',
      label: 'Contract List',
      icon: FileTextIcon
    }, {
      id: 'contract-management',
      label: 'Contract Dashboard',
      icon: BarChartIcon
    }, {
      id: 'contract-milestones',
      label: 'Milestones',
      icon: CalendarIcon
    }, {
      id: 'contract-payment-claims',
      label: 'Payment Claims',
      icon: DollarSignIcon
    }, {
      id: 'contract-types',
      label: 'Contract Types',
      icon: LayoutIcon
    }, {
      id: 'contract-variations',
      label: 'Variations',
      icon: GitBranchIcon
    }], 'contract-management')
  }, {
    id: 'ap-management',
    label: 'AP',
    icon: ReceiptIcon,
    tooltip: 'Accounts Payable',
    isDropdown: true,
    isActive: isApView,
    children: sortMenuItems([{
      id: 'credit-note-dashboard',
      label: 'Credit Notes',
      icon: MinusSquareIcon
    }, {
      id: 'credit-note-entry',
      label: 'Credit Note Entry',
      icon: MinusSquareIcon
    }, {
      id: 'ap-dashboard',
      label: 'Dashboard',
      icon: BarChartIcon
    }, {
      id: 'invoice-entry',
      label: 'Invoice Entry',
      icon: FileIcon
    }, {
      id: 'invoice-list',
      label: 'Invoices',
      icon: FilesIcon
    }, {
      id: 'rcti-management',
      label: 'RCTIs',
      icon: FileTextIcon
    }, {
      id: 'statement-reconciliation',
      label: 'Statement Reconciliation',
      icon: FileBarChart2Icon
    }], 'ap-dashboard')
  }, {
    id: 'expense-management',
    label: 'EM',
    icon: CreditCardIcon,
    tooltip: 'Expense Management',
    isDropdown: true,
    isActive: isExpenseView,
    children: sortMenuItems([{
      id: 'add-expense-claim',
      label: 'Add New Expense',
      icon: PlusIcon
    }, {
      id: 'expense-approval',
      label: 'Approval',
      icon: CheckSquareIcon
    }, {
      id: 'expense-management',
      label: 'Expense Dashboard',
      icon: BarChartIcon
    }, {
      id: 'expense-claim-detail',
      label: 'Expense List',
      icon: FileTextIcon
    }], 'expense-management')
  }, {
    id: 'financial-management',
    label: 'FM',
    icon: DollarSignIcon,
    tooltip: 'Financial Management',
    isDropdown: true,
    isActive: isFinancialView,
    children: sortMenuItems([{
      id: 'budget',
      label: 'Budget',
      icon: PieChartIcon
    }, {
      id: 'chart-of-accounts',
      label: 'Chart of Accounts',
      icon: BookIcon
    }, {
      id: 'countries',
      label: 'Countries',
      icon: GlobeIcon
    }, {
      id: 'currency',
      label: 'Currencies',
      icon: CoinsIcon
    }, {
      id: 'currency-exchange',
      label: 'Currency Exchange',
      icon: DollarSignIcon
    }, {
      id: 'decimal-precision',
      label: 'Decimal Precision',
      icon: DollarSignIcon
    }, {
      id: 'delegations',
      label: 'Delegations',
      icon: UserIcon
    }, {
      id: 'ledger',
      label: 'Ledger',
      icon: DatabaseIcon
    }, {
      id: 'payments',
      label: 'Payments',
      icon: CreditCardIcon
    }, {
      id: 'rounding',
      label: 'Rounding',
      icon: CircleDotIcon
    }, {
      id: 'rules',
      label: 'Rules',
      icon: BookmarkIcon
    }, {
      id: 'tax-codes',
      label: 'Tax Codes',
      icon: PercentIcon
    }, {
      id: 'tolerance',
      label: 'Tolerance',
      icon: ScaleIcon
    }, {
      id: 'workflows',
      label: 'Workflows',
      icon: GitBranchIcon
    }, {
      id: 'communications',
      label: 'Communications',
      icon: MessageSquareIcon
    }, {
      id: 'contacts',
      label: 'Contacts',
      icon: UsersIcon
    }, {
      id: 'bank-accounts',
      label: 'Bank Accounts',
      icon: CreditCardIcon
    }, {
      id: 'addresses',
      label: 'Addresses',
      icon: MapPinIcon
    }], 'chart-of-accounts')
  }, {
    id: 'reports',
    label: 'Reports',
    icon: FileBarChart2Icon,
    isDropdown: true,
    isActive: isReportsView,
    children: sortMenuItems([{
      id: 'reports',
      label: 'All Reports',
      icon: FileBarChart2Icon
    }, {
      id: 'reports-ap',
      label: 'AP',
      icon: ReceiptIcon
    }, {
      id: 'reports-audit',
      label: 'Audit & Compliance',
      icon: ShieldCheckIcon
    }, {
      id: 'reports-construction',
      label: 'Construction',
      icon: HomeIcon
    }, {
      id: 'reports-financial',
      label: 'Financial',
      icon: DollarSignIcon
    }, {
      id: 'reports-operational',
      label: 'Operational Analytics',
      icon: LineChartIcon
    }, {
      id: 'reports-procurement',
      label: 'Procurement',
      icon: ShoppingCartIcon
    }, {
      id: 'reports-requisition',
      label: 'Requisition',
      icon: ClipboardIcon
    }], 'reports')
  }, {
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon,
    isDropdown: true,
    isActive: isSettingsView,
    children: sortMenuItems([{
      id: 'audit',
      label: 'Audit',
      icon: ClipboardListIcon
    }, {
      id: 'document-traceability',
      label: 'Document Traceability',
      icon: ShieldAlertIcon
    }, {
      id: 'email-configuration',
      label: 'Email Configuration',
      icon: MailIcon
    }, {
      id: 'settings',
      label: 'Organisation Unit Management',
      icon: BuildingIcon
    }, {
      id: 'license-manager',
      label: 'License Manager',
      icon: KeyIcon
    }, {
      id: 'messages',
      label: 'Messages & Templates',
      icon: MessageSquareIcon
    }, {
      id: 'notifications',
      label: 'Notifications',
      icon: BellIcon
    }, {
      id: 'status-management',
      label: 'Status Management',
      icon: FilterIcon
    }, {
      id: 'tags',
      label: 'Tags',
      icon: TagIcon
    }, {
      id: 'users',
      label: 'User Management',
      icon: UsersIcon
    }], 'settings')
  }];
  // Handle clicks outside dropdown menus to close them
  useEffect(() => {
    const handleClickOutside = event => {
      // Dashboard menu
      if (dashboardMenuOpen && !dashboardButtonRef.current?.contains(event.target) && !dashboardMenuRef.current?.contains(event.target)) {
        setDashboardMenuOpen(false);
      }
      // Procurement menu
      if (procurementMenuOpen && !procurementButtonRef.current?.contains(event.target) && !procurementMenuRef.current?.contains(event.target)) {
        setProcurementMenuOpen(false);
      }
      // Vendor menu
      if (vendorMenuOpen && !vendorButtonRef.current?.contains(event.target) && !vendorMenuRef.current?.contains(event.target)) {
        setVendorMenuOpen(false);
      }
      // AP menu
      if (apMenuOpen && !apButtonRef.current?.contains(event.target) && !apMenuRef.current?.contains(event.target)) {
        setApMenuOpen(false);
      }
      // DI menu
      if (diMenuOpen && !diButtonRef.current?.contains(event.target) && !diMenuRef.current?.contains(event.target)) {
        setDIMenuOpen(false);
      }
      // Financial menu
      if (financialMenuOpen && !financialButtonRef.current?.contains(event.target) && !financialMenuRef.current?.contains(event.target)) {
        setFinancialMenuOpen(false);
      }
      // Settings menu
      if (settingsMenuOpen && !settingsButtonRef.current?.contains(event.target) && !settingsMenuRef.current?.contains(event.target)) {
        setSettingsMenuOpen(false);
      }
      // Reports menu
      if (reportsMenuOpen && !reportsButtonRef.current?.contains(event.target) && !reportsMenuRef.current?.contains(event.target)) {
        setReportsMenuOpen(false);
      }
      // Contract menu
      if (contractMenuOpen && !contractButtonRef.current?.contains(event.target) && !contractMenuRef.current?.contains(event.target)) {
        setContractMenuOpen(false);
      }
      // Expense menu
      if (expenseMenuOpen && !expenseButtonRef.current?.contains(event.target) && !expenseMenuRef.current?.contains(event.target)) {
        setExpenseMenuOpen(false);
      }
      // Mobile menu
      if (mobileMenuOpen && !mobileMenuButtonRef.current?.contains(event.target) && !mobileMenuRef.current?.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dashboardMenuOpen, procurementMenuOpen, vendorMenuOpen, apMenuOpen, diMenuOpen, financialMenuOpen, settingsMenuOpen, reportsMenuOpen, contractMenuOpen, expenseMenuOpen, mobileMenuOpen]);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const toggleMobileSubmenu = id => {
    setActiveMobileSubmenu(activeMobileSubmenu === id ? null : id);
  };
  // Helper function to render dropdown menu items
  const renderDropdownMenu = (menuRef, item) => <div ref={menuRef} className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-13294">
      <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-13295">
        {item.children.map(child => <button key={child.id} onClick={() => {
        setCurrentView(child.id);
        // Close the corresponding menu
        switch (item.id) {
          case 'dashboard':
            setDashboardMenuOpen(false);
            break;
          case 'di-management':
            setDIMenuOpen(false);
            break;
          case 'vendor-management':
            setVendorMenuOpen(false);
            break;
          case 'procurement':
            setProcurementMenuOpen(false);
            break;
          case 'ap-management':
            setApMenuOpen(false);
            break;
          case 'financial-management':
            setFinancialMenuOpen(false);
            break;
          case 'settings':
            setSettingsMenuOpen(false);
            break;
          case 'reports':
            setReportsMenuOpen(false);
            break;
          case 'contract-management':
            setContractMenuOpen(false);
            break;
          case 'expense-management':
            setExpenseMenuOpen(false);
            break;
          default:
            break;
        }
      }} className={`block w-full text-left px-4 py-2 text-sm ${currentView === child.id ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-13296">
            <div className="flex items-center" data-id="element-13297">
              <child.icon className="h-4 w-4 mr-2" data-id="element-13298" />
              {child.label}
            </div>
          </button>)}
      </div>
    </div>;
  return <nav className="bg-white border-b border-gray-200" data-id="element-13299">
      <div className="w-[85%] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13300">
        <div className="flex items-center justify-between h-16" data-id="element-13301">
          <div className="flex items-center" data-id="element-13302">
            <div className="hidden md:block" data-id="element-13303">
              <div className="flex items-baseline space-x-4" data-id="element-13304">
                {/* Dashboard Dropdown */}
                <div className="relative" data-id="element-13305">
                  <button onClick={() => setCurrentView('dashboard')} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isDashboardView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13306">
                    <HomeIcon className="h-5 w-5 mr-1" data-id="element-13307" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13308">Dashboard</span>
                  </button>
                </div>
                {/* DI Dropdown */}
                <div className="relative" data-id="element-13309">
                  <button ref={diButtonRef} onClick={() => setDIMenuOpen(!diMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isDIView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13310">
                    <FileTextIcon className="h-5 w-5 mr-1" data-id="element-13311" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13312">DI</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13313" />
                  </button>
                  {diMenuOpen && renderDropdownMenu(diMenuRef, navItems.find(item => item.id === 'di-management'))}
                </div>
                {/* Vendor Management Dropdown */}
                <div className="relative" data-id="element-13314">
                  <button ref={vendorButtonRef} onClick={() => setVendorMenuOpen(!vendorMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isVendorView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13315">
                    <UsersIcon className="h-5 w-5 mr-1" data-id="element-13316" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13317">VM</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13318" />
                  </button>
                  {vendorMenuOpen && renderDropdownMenu(vendorMenuRef, navItems.find(item => item.id === 'vendor-management'))}
                </div>
                {/* Procurement dropdown */}
                <div className="relative" data-id="element-13319">
                  <button ref={procurementButtonRef} onClick={() => setProcurementMenuOpen(!procurementMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isProcurementView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13320">
                    <ShoppingCartIcon className="h-5 w-5 mr-1" data-id="element-13321" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13322">PO</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13323" />
                  </button>
                  {procurementMenuOpen && renderDropdownMenu(procurementMenuRef, navItems.find(item => item.id === 'procurement'))}
                </div>
                {/* Contract Management Dropdown */}
                <div className="relative" data-id="element-13324">
                  <button ref={contractButtonRef} onClick={() => setContractMenuOpen(!contractMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isContractView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13325">
                    <FileSignatureIcon className="h-5 w-5 mr-1" data-id="element-13326" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13327">CM</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13328" />
                  </button>
                  {contractMenuOpen && renderDropdownMenu(contractMenuRef, navItems.find(item => item.id === 'contract-management'))}
                </div>
                {/* AP Management Dropdown */}
                <div className="relative" data-id="element-13329">
                  <button ref={apButtonRef} onClick={() => setApMenuOpen(!apMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isApView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13330">
                    <ReceiptIcon className="h-5 w-5 mr-1" data-id="element-13331" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13332">AP</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13333" />
                  </button>
                  {apMenuOpen && renderDropdownMenu(apMenuRef, navItems.find(item => item.id === 'ap-management'))}
                </div>
                {/* Expense Management Dropdown */}
                <div className="relative" data-id="element-13334">
                  <button ref={expenseButtonRef} onClick={() => setExpenseMenuOpen(!expenseMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isExpenseView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13335">
                    <CreditCardIcon className="h-5 w-5 mr-1" data-id="element-13336" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13337">EM</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13338" />
                  </button>
                  {expenseMenuOpen && renderDropdownMenu(expenseMenuRef, navItems.find(item => item.id === 'expense-management'))}
                </div>
                {/* Financial Management Dropdown */}
                <div className="relative" data-id="element-13339">
                  <button ref={financialButtonRef} onClick={() => setFinancialMenuOpen(!financialMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isFinancialView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13340">
                    <DollarSignIcon className="h-5 w-5 mr-1" data-id="element-13341" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13342">FM</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13343" />
                  </button>
                  {financialMenuOpen && renderDropdownMenu(financialMenuRef, navItems.find(item => item.id === 'financial-management'))}
                </div>
                {/* Reports Dropdown */}
                <div className="relative" data-id="element-13344">
                  <button ref={reportsButtonRef} onClick={() => setReportsMenuOpen(!reportsMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isReportsView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13345">
                    <FileBarChart2Icon className="h-5 w-5 mr-1" data-id="element-13346" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13347">Reports</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13348" />
                  </button>
                  {reportsMenuOpen && renderDropdownMenu(reportsMenuRef, navItems.find(item => item.id === 'reports'))}
                </div>
                {/* Settings Dropdown */}
                <div className="relative" data-id="element-13349">
                  <button ref={settingsButtonRef} onClick={() => setSettingsMenuOpen(!settingsMenuOpen)} className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${isSettingsView ? 'bg-indigo-100 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13350">
                    <SettingsIcon className="h-5 w-5 mr-1" data-id="element-13351" />
                    <span className="sr-only sm:not-sr-only" data-id="element-13352">Settings</span>
                    <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-13353" />
                  </button>
                  {settingsMenuOpen && renderDropdownMenu(settingsMenuRef, navItems.find(item => item.id === 'settings'))}
                </div>
              </div>
            </div>
          </div>
          {/* Mobile menu button */}
          <div className="flex md:hidden" data-id="element-13354">
            <button ref={mobileMenuButtonRef} onClick={toggleMobileMenu} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none" data-id="element-13355">
              <span className="sr-only" data-id="element-13356">Open main menu</span>
              {mobileMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-13357" /> : <MenuIcon className="block h-6 w-6" data-id="element-13358" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div ref={mobileMenuRef} className="md:hidden" data-id="element-13359">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-13360">
            {/* Mobile menu items for all nav sections */}
            {navItems.map(item => <div key={item.id} data-id="element-13361">
                {item.isDropdown ?
          // Items with dropdowns
          <>
                    <button onClick={() => toggleMobileSubmenu(item.id)} className={`w-full flex justify-between items-center px-3 py-2 rounded-md text-base font-medium ${item.isActive ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13362">
                      <div className="flex items-center" data-id="element-13363">
                        <item.icon className="h-5 w-5 mr-2" data-id="element-13364" />
                        {item.tooltip || item.label}
                      </div>
                      <ChevronDownIcon className={`h-5 w-5 transform ${activeMobileSubmenu === item.id ? 'rotate-180' : ''}`} data-id="element-13365" />
                    </button>
                    {activeMobileSubmenu === item.id && <div className="pl-6 pr-2 py-2 space-y-1" data-id="element-13366">
                        {item.children.map(child => <button key={child.id} onClick={() => {
                setCurrentView(child.id);
                setMobileMenuOpen(false);
              }} className={`block w-full text-left px-3 py-2 rounded-md text-sm font-medium ${currentView === child.id ? 'bg-indigo-50 text-indigo-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13367">
                            <div className="flex items-center" data-id="element-13368">
                              <child.icon className="h-4 w-4 mr-2" data-id="element-13369" />
                              {child.label}
                            </div>
                          </button>)}
                      </div>}
                  </> :
          // Items without dropdowns (like Dashboard)
          <button onClick={() => {
            setCurrentView(item.id);
            setMobileMenuOpen(false);
          }} className={`w-full flex items-center px-3 py-2 rounded-md text-base font-medium ${item.isActive ? 'bg-indigo-100 text-indigo-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-13370">
                    <div className="flex items-center" data-id="element-13371">
                      <item.icon className="h-5 w-5 mr-2" data-id="element-13372" />
                      {item.label}
                    </div>
                  </button>}
              </div>)}
          </div>
        </div>}
    </nav>;
}